import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom';
import { Dropdown, NavDropdown } from "react-bootstrap"
import navImg from '../assets/PCWI_Logo.svg'

export default function Navbar() {

    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    return (
        <div>
            <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#2F3D57' }}>
                <div className="container justify-content-between">
                    <a className="navbar-brand">
                        <img src={navImg} style={{ height: "70px" }} draggable='false' alt="Parker County Water Plan" className="me-3" />
                        <h4 id="navbarH4" className="d-none d-lg-inline ms-3" style={{ verticalAlign: "middle" }}>Parker County Water Plan</h4>
                    </a>
                    <h5 className="">
                        <a href="mailto:PC_Water@freese.com" title="Email us at PC_Water@freese.com" style={{ color: "white", textDecoration: "none" }}>
                            📧 Contact Us
                        </a>
                    </h5>
                    <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg navbar-dark py-0 shadow-sm" style={{ backgroundColor: "#FAAB53" }}>
                <div className="container">
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <div className="navbar-nav fw-medium fw-bold" style={{ fontSize: "20px" }}>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "" ? "active" : "notActive")} to="/" >Home</Link>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "Events" || splitLocation[1] === "ViewEvent" ? "active" : "notActive")} to="/Events">Events</Link>
                            <Link className="nav-link" id={(splitLocation[1] === "Calendar" ? "active" : "notActive")} to="/Calendar">Calendar</Link>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}